import { createReducer, on } from '@ngrx/store';
import { setPatientIdSuccess } from '../../../user/store/actions/user.actions';
import { PatientProfile } from '../../models/patient-profile';
import {
  getFullProfile,
  getFullProfileFailure,
  getFullProfileSuccess,
  getProfile,
  getProfileFailure,
  getProfileSuccess,
  saveProfile,
  saveProfileFailure,
  saveProfileSuccess,
} from '../actions/profile.actions';
import { FullPatientProfile } from '../../models/full-patient-profile';

export const profileFeatureKey = 'profile';

export interface ProfileState {
  profile: PatientProfile | null;
  fullProfile: FullPatientProfile | null;
  error: unknown;
  isLoading: boolean;
  isSaving: boolean;
}

export const initialState: ProfileState = {
  profile: null,
  fullProfile: null,
  error: null,
  isLoading: false,
  isSaving: false,
};

export const profileReducer = createReducer<ProfileState>(
  initialState,

  on(getProfile, setPatientIdSuccess, (state): ProfileState => {
    return {
      ...state,
      profile: null,
    };
  }),

  on(getProfileSuccess, (state, { profile }): ProfileState => {
    return {
      ...state,
      profile,
      error: null,
    };
  }),

  on(getProfileFailure, (state, { error }): ProfileState => {
    return {
      ...state,
      profile: null,
      error,
    };
  }),

  on(saveProfile, (state): ProfileState => {
    return {
      ...state,
      isSaving: true,
    };
  }),

  on(saveProfileSuccess, (state, { profile }): ProfileState => {
    return {
      ...state,
      profile,
      error: null,
      isSaving: false,
    };
  }),

  on(saveProfileFailure, (state, { error }): ProfileState => {
    return {
      ...state,
      profile: null,
      error,
      isSaving: false,
    };
  }),

  on(getFullProfile, setPatientIdSuccess, (state): ProfileState => {
    return {
      ...state,
      fullProfile: null,
      isLoading: true,
    };
  }),

  on(getFullProfileSuccess, (state, { fullProfile }): ProfileState => {
    return {
      ...state,
      fullProfile,
      error: null,
      isLoading: false,
    };
  }),

  on(getFullProfileFailure, (state, { error }): ProfileState => {
    return {
      ...state,
      fullProfile: null,
      error,
      isLoading: false,
    };
  })
);
